module.exports = __webpack_public_path__ + "static/media/sim-broadcasts-logo-t-b.ec8cbf64.png";